<script>
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrPerfDonem from "@/models/StrPerfDonem";

export default {
  mixins: [Api, Sabit, StrPerfDonem],
  props: ["TanimId", "Guncelle"],
  data() {
    return {
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      TableData: [],
      DataUpdateAlt: null,
      Gosterge: null,
      UstBaslama_tarihi: "",
      UstBitis_tarihi: "",
      Ustyilbas: "",
      Ustyilbit: "",
    };
  },
  component: {},

  watch: {
    Guncelle() {
      this.Get();
    },
  },

  methods: {
    veri_gonder(data, islem) {
      this.$emit("DataUpdate", data);
      this.$emit("AddEdit", islem);
      this.$emit("min_tarih", this.UstBaslama_tarihi);
      this.$emit("max_tarih", this.UstBitis_tarihi);
      this.$emit("min_yilbas", this.Ustyilbas.toString());
      this.$emit("max_yilbit", this.Ustyilbit.toString());
    },

    Get() {

      this.ActionsGet({ Service: "StrPerfDonem/" + this.TanimId, Page: this.Page }).then((res) => {
        this.UstBaslama_tarihi = res.Data.BaslamaTarihi;
        this.UstBitis_tarihi = res.Data.BitisTarihi;
        this.Ustyilbas = res.Data.YilBas;
        this.Ustyilbit = res.Data.YilBit;
      });

      let Filter = "&UstId=" + this.TanimId;
      this.ActionsFilterGet({ Service: "StrPerfDonem", Page: this.Page, Filter: Filter + "&Asc=Sira" }).then((res) => {
        this.TableData = res.Data;
        this.Page.PageDataSize = res.TotalCount;
      });
    },
  },
  created() {
    this.Get();
  },
};
</script>
<template>
  <div>

    <div class="table-responsive">
      <table class="table mb-0">
        <thead class="table-light">
          <tr>
           <!-- <th></th>-->
            <th scope="col">{{ $t("StrPerfDonem.Table.Sira") }}</th>
            <th scope="col">{{ $t("StrPerfDonem.Table.TipValue") }}</th>
            <th scope="col">{{ $t("StrPerfDonem.Table.Aciklama") }}</th>
            <th scope="col">{{ $t("StrPerfDonem.Table.BaslamaTarihi") }}</th>
            <th scope="col">{{ $t("StrPerfDonem.Table.BitisTarihi") }}</th>
            <th style="width: 100px; text-align: center; vertical-align: middle;">{{ $t("StrPerfDonem.Table.Approval") }}</th>
            <th style="width: 100px; text-align: center; vertical-align: middle;">{{ $t("StrPerfDonem.Table.Hedefmi") }}</th>
            <th style="width: 100px; text-align: center; vertical-align: middle;">{{ $t("StrPerfDonem.Table.Islem") }}</th>
          </tr>
        </thead>
        <tbody v-for="Data in TableData" :key="Data.Id">
          <tr>
          <!-- <th scope="row" class="custom-accordion">
              <a class="text-body fw-medium py-1 d-flex align-items-center" data-toggle="collapse" v-b-toggle="'CollapseAltTablo' + Data.Id" role="button" aria-expanded="false" aria-controls="categories-collapse">
                <i class="mdi mdi-chevron-up accor-down-icon ms-auto"></i>
              </a>
            </th>--> 
            <td>{{ Data.Sira }}</td>
            <td>{{ Data.TipValue }}</td>
            <td>{{ Data.Aciklama }}</td>
            <td>{{ Data.BaslamaTarihi | formatDateTable }}</td>
            <td>{{ Data.BitisTarihi | formatDateTable }}</td>
            <td style="width: 100px; text-align: center; vertical-align: middle;">
              <i v-if="Data.Approval" class="fas fas fa-check"></i>
              <i v-if="!Data.Approval" class="fas fas fa-times"></i>
            </td>
            <td style="width: 100px; text-align: center; vertical-align: middle;">
              <i v-if="Data.VeriTipi==2" class="fas fas fa-check"></i>
                      <i v-if="Data.VeriTipi!=2" class="fas fas fa-times"></i>
            </td>
            <td style="width: 100px; text-align: center; vertical-align: middle;">
              <b-button-group>
                <b-button variant="primary" v-b-modal.StrPerfDonem @click="veri_gonder(Data, 'Edit')"><i class="fas fa-pencil-alt"></i></b-button>
                <b-button variant="danger" @click="Delete('StrPerfDonem', Data.Id)"><i class="fas fa-trash-alt"></i></b-button>
              </b-button-group>
            </td>
          </tr>

        <!--  <tr>
            <td colspan="10">
              <b-collapse class="collapse show" :id="'CollapseAltTablo' + Data.Id">
                <table class="table mb-0">
                  <thead>
                    <tr>
                      <th scope="col">Kalite Öz Değer Başl. Tarihi</th>
                      <td>
                        {{ Data.IcDegerBaslamaTarihi | formatDateTable }}
                      </td>

                      <th scope="col">Risk Değer. Başl. Tarihi</th>
                      <td>
                        {{ Data.RiskDegerBaslamaTarihi | formatDateTable }}
                      </td>

                      <th scope="col">Proses Değer Başl. Tarihi</th>
                      <td>
                        {{ Data.ProsesDegerBaslamaTarihi | formatDateTable }}
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="col">Kalite Öz Deger Bit. Tarihi</th>
                      <td>
                        {{ Data.IcDegerBitisTarihi | formatDateTable }}
                      </td>
                      <th scope="col">Risk Değer Bitiş Tarihi</th>
                      <td>
                        {{ Data.RiskDegerBitisTarihi | formatDateTable }}
                      </td>

                      <th scope="col">Proses Değer Bitiş Tarihi</th>
                      <td>
                        {{ Data.ProsesDegerBitisTarihi | formatDateTable }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-collapse>
            </td>
          </tr>-->

        </tbody>
      </table>
    </div>
  </div>
</template>
